import Amplify, { API } from 'aws-amplify';
import config from '../aws-exports';

Amplify.configure(config);
async function LoadData () :  Promise<SiteData> {
    // add query string to ensure fresh load of site data on every visit
    const s3DataResponse = await fetch(`https://${config.aws_user_files_s3_bucket}.s3.${config.aws_user_files_s3_bucket_region}.amazonaws.com/Outputs/SiteDataBundle.json?cacheBust=${Date.now()}`);
    const s3Data = await s3DataResponse.json();
    //console.log("site-data response: " + JSON.stringify(s3Data));
    return s3Data;
} 
// start loading immediately
const loadDataCall = LoadData();

export class SiteData
{
    Teams: Array<TeamData> ;
    ImageDescriptors: Array<ImageDescriptorData>;
    People: Array<PersonData>;
    Posts: Array<PostDataExtended>;
}

export class TeamData
{
    id: string;
    year: number;
    grade: string;
    team_number: string;
    result?: string;
    minor_premiers?: string;
    team_image_id?: string
}
export class TeamIdFragments
{
    year: number;
    grade: string;
    team_number: string;
}

export class PersonData
{
    id: string;
    name: string;
    teams: string[];
}

export class ImageDescriptorData
{
    id: string;
    creator: any;
    created: Date;
    original_image: string;
    public_image?: string;
    is_approved: boolean;
    is_reviewed: boolean;
    subjects: Array<ImageSubject>;
    name: string;
    caption?: string;
    image_type: string;
    teams: Array<string>;
    full_metadata: any;
}


export class ImageSubject
{
    row: number;
    column: number;
    name?: string;
    role?: string;
}

export class PostData
{
    title: string;
    body: string;
    type: string;
    active: boolean;
}

export class PostDataExtended extends PostData
{
    id: string;
    created: string
}

export async function GetSiteData() : Promise<SiteData> {
    return await loadDataCall;
}

class KeyDisplay
{
    Key: string;
    Display: string;
    Selection: string;

    /**
     *
     */
    constructor(key: string, display?: string, selection?: string) {
        this.Key = key;
        
        if (display != null) {
            this.Display = display;
        } else {
            this.Display = this.Key;
        }

        if (selection != null){
            this.Selection = selection;
        } else {
            this.Selection = this.Display;
        }
    }
}

export function Years() : Array<number> {
    const years : Array<number> = [];

    years.push(1912);
    years.push(1926);
    years.push(1927);
    years.push(1928);
    years.push(1929);
    years.push(1930);
    years.push(1931);
    years.push(1947);

    const startYear = 1959;
    const finalYear = 1995;
    for (var year = startYear; year <= finalYear; year++) {
        years.push(year);
    }
    return years;
}

export function Grades() : Array<KeyDisplay> {
    return [
        new KeyDisplay("A", "A Grade"),
        new KeyDisplay("B", "B Grade"),
        new KeyDisplay("C", "C Grade"),
        new KeyDisplay("U21", "Under 21s"),
        new KeyDisplay("U20", "Under 20s"),
        new KeyDisplay("U19", "Under 19s"),
        new KeyDisplay("U18", "Under 18s"),
        new KeyDisplay("U17", "D Grade (U/17)"),
        new KeyDisplay("U16", "D Reserve (U/16)"),
        new KeyDisplay("U15", "E Grade (U/15)"),
        new KeyDisplay("U14", "E Reserve (U/14)"),
        new KeyDisplay("U13", "F Grade (U/13)"),
        new KeyDisplay("U12", "F Reserve (U/12)"),
        new KeyDisplay("U11", "G Grade (U/11)"),
        new KeyDisplay("U10", "G Reserve (U/10)"),
        new KeyDisplay("U9", "H Grade (U/9)"),
        new KeyDisplay("U8", "H Reserve (U/8)"),
        new KeyDisplay("U7", "I Grade (U/7)"),
    ];
}

export function TeamNumbers() : Array<KeyDisplay> {
    return [
        new KeyDisplay("0", "", "Single Team"),
        new KeyDisplay("1", "1st Team", "1"),
        new KeyDisplay("2", "2nd Team", "2"),
        new KeyDisplay("3", "3rd Team", "3"),
    ];
}

export function TeamResults() : Array<KeyDisplay> {
    return [
        new KeyDisplay("Undefeated Premiers"),
        new KeyDisplay("Premiers"),
        new KeyDisplay("Grand Finalists"),
        new KeyDisplay("Finalists"),
        new KeyDisplay("Semi Finalists"),
        new KeyDisplay("Other"),
    ];
}

export function TeamRoles() : Array<KeyDisplay> {
    return [
        new KeyDisplay("Player"),
        new KeyDisplay("Captain"),
        new KeyDisplay("Vice-Captain", "Vice Captain"),
        new KeyDisplay("Coach"),
        new KeyDisplay("Manager"),
        new KeyDisplay("Trainer"),
        new KeyDisplay("Ball-Person", "Ball-Boy"),
        new KeyDisplay("Asst-Coach", "Asst. Coach"),
        new KeyDisplay("Asst-Manager", "Asst. Manager"),
        new KeyDisplay("Asst-Secretary", "Asst. Secretary"),
        new KeyDisplay("Asst-Trainer", "Asst. Trainer"),
        new KeyDisplay("Co-Manager", "Co-Manager"),
        new KeyDisplay("Committee", "Committee"),
        new KeyDisplay("Co-Trainer", "Co-Trainer"),
        new KeyDisplay("Hon-Secretary", "Hon. Secretary"),
        new KeyDisplay("Mascot", "Mascot"),
        new KeyDisplay("Official"),
        new KeyDisplay("Patron", "Patron"),
        new KeyDisplay("President", "President"),
        new KeyDisplay("Sand-Boy", "Sand-Boy"),
        new KeyDisplay("Secretary", "Secretary"),
        new KeyDisplay("Secretary-WSJL", "Secretary W.S.J.L."),
        new KeyDisplay("Selector", "Selector"),
        new KeyDisplay("Sponsor", "Sponsor"),
        new KeyDisplay("Statistician", "Statistician"),
        new KeyDisplay("Strapper", "Strapper"),
        new KeyDisplay("Time-Keeper", "Time Keeper"),
        new KeyDisplay("Treasurer", "Treasurer"),
        new KeyDisplay("Vice-President", "Vice-President"),
    ];
}

export function PostTypes() : Array<KeyDisplay> {
    return [
        new KeyDisplay("News"),
        new KeyDisplay("SiteIntro", "Site Article"),
    ];
}

export function ImageTypes() : Array<KeyDisplay> {
    return [
        new KeyDisplay("General"),
        new KeyDisplay("TeamPhoto"),
    ];
}

export enum ImageSize {
    SrcSet,
    SrcSetSizes,
    Full,
    Small,
    Medium,
    Large
}

export async function RetriggerFile(path: string) {
    const API_NAME = 'photos';
    const PATH = '/site-data'; 
    const result = await API.put(API_NAME, `${PATH}?action=retrigger&id=${path}`, {});
    return true;
}

export async function RetriggerAllImages() {
    const API_NAME = 'photos';
    const PATH = '/site-data'; 
    const result = await API.put(API_NAME, `${PATH}?action=retrigger&prefix=Images`, {});
    return true;
}

export class DataUtils
{
    static LookupDisplay(values: Array<KeyDisplay>, key: string) : string {
        let entry = values.find(kd => kd.Key === key);
        if (entry != null) {
            return entry.Display;
        }
        return "";
    }

    static TeamName(team: TeamIdFragments) : string {
        let teamName = `${team.year} ${this.LookupDisplay(Grades(), team.grade)} ${this.LookupDisplay(TeamNumbers(), team.team_number)}`.trimEnd();
        return teamName;
    }

    static GetImageUrl(imageId: string | undefined, size: ImageSize) : string|undefined {
        if (imageId == null) {
            return undefined;
        }

        const getImage = () => `https://${config.aws_user_files_s3_bucket}.s3.${config.aws_user_files_s3_bucket_region}.amazonaws.com/Images/${imageId}.jpg`;
        const getThumb = px => `https://${config.aws_user_files_s3_bucket}.s3.${config.aws_user_files_s3_bucket_region}.amazonaws.com/Thumbnails/${imageId}_${px}.jpg`;
        // const getImage = () => `/Images/${imageId}.jpg`;
        // const getThumb = px => `/Thumbnails/${imageId}_${px}.jpg`;

        if (size === ImageSize.Small) {
            return getThumb(400);
        }
        else if (size === ImageSize.Medium) {
            return getThumb(1200);
        }
        else if (size === ImageSize.Large) {
            return getThumb(1920);
        }
        else if (size === ImageSize.Full) {
            return getImage();
        }
        else if (size === ImageSize.SrcSet) {
            return `${getThumb(400)} 400w, ${getThumb(1200)} 1200w, ${getThumb(1920)} 1920w, ${getImage()} 10000w`;
        } else if (size === ImageSize.SrcSetSizes) {
            return `(max-width: 400px) 400px, (max-width: 1200px) 1200px, (max-width: 1920px) 1920px, 10000px`
        }

        return getImage();
    }

    static BestTeamImageDescriptor(siteData: SiteData, team: TeamData) : (ImageDescriptorData | undefined) {
        if (team.team_image_id != null) {
            let image = siteData.ImageDescriptors.find(id => id.id === team.team_image_id);
            if (image != null) {
                return image;
            }
        }

        let otherImage = siteData.ImageDescriptors.find(id => id.image_type === "TeamPhoto" && id.teams.find(t => t === team.id) != null);
        if (otherImage != null) {
            return otherImage;
        }

        return undefined;
    }
    static BestTeamImage(siteData: SiteData, team: TeamData, size: ImageSize) : (string | undefined) {
        const imageDescriptor = this.BestTeamImageDescriptor(siteData, team);
        if (imageDescriptor == null){
            return undefined;
        }
        return this.GetImageUrl(imageDescriptor.public_image ?? imageDescriptor.original_image, size);
    }


}

